export default (state, action) => {
  const {
    payload,
  } = action;

  switch (action.type) {
    case 'GO_TO_WELCOME_PAGE':
      return {
        ...state,
        curPage: 'WelcomePage',
      };
    case 'GO_TO_REVIEW_ACCOUNT_PAGE':
      return {
        ...state,
        curPage: 'ReviewAccountPage',
      };
    case 'GO_TO_ERROR_PAGE':
      return {
        ...state,
        curPage: 'errorPage',
        errorType: payload,
      };
    case 'GO_TO_SUCCESS_PAGE':
      return {
        ...state,
        curPage: 'successPage',
        hulaResponse: payload.hulaResponse,
        currentHULADetails: {
          ...state.currentHULADetails,
          productKey: payload.productKey,
        },
      };
    case 'GO_TO_CREAT_CASE_SUCCESS_PAGE':
      return {
        ...state,
        curPage: 'createCaseSuccessPage',
        caseNumber: payload.caseNumber,
      };
    case 'GO_TO_SPIN_PAGE':
      return {
        ...state,
        curPage: 'processSpinPage',
      };
    case 'GO_TO_CREATE_CASE_PAGE':
      return {
        ...state,
        prevPage: state.curPage,
        curPage: 'createCasePage',
      };
    case 'GO_TO_PREV_PAGE':
      return {
        ...state,
        curPage: state.prevPage,
      };
    case 'GO_TO_PRODUCT_INFO_PAGE':
      return {
        ...state,
        curPage: 'ProductInfoPage',
      };
    case 'GO_TO_AGENT_AVAILABLE_PAGE':
      return {
        ...state,
        curPage: 'agentAvailable',
      }
    case 'GO_TO_AUTHORIZE_PAGE':
      return {
        ...state,
        curPage: 'authorizeRequestPage',
      };
    default:
      return state;
  }
};
